'use client';

import {useEffect, useRef} from 'react';

export const useScrollLock = (locked: boolean) => {
	const scrollYRef = useRef(0);

	useEffect(() => {
		if (locked) {
			scrollYRef.current = window.scrollY;

			const html = document.documentElement;
			const body = document.body;
			const scrollbarWidth = window.innerWidth - html.clientWidth;

			html.style.overflow = 'hidden';
			body.style.overflow = 'hidden';
			html.style.overscrollBehavior = 'contain';
			body.style.overscrollBehavior = 'contain';
			body.style.position = 'fixed';
			body.style.top = `-${scrollYRef.current}px`;
			body.style.width = '100%';
			body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
		} else {
			const html = document.documentElement;
			const body = document.body;

			html.style.overflow = '';
			body.style.overflow = '';
			html.style.overscrollBehavior = '';
			body.style.overscrollBehavior = '';
			body.style.position = '';
			body.style.top = '';
			body.style.width = '';
			body.style.paddingRight = '';

			window.scrollTo(0, scrollYRef.current);
		}

		return () => {
			if (locked) {
				const html = document.documentElement;
				const body = document.body;

				html.style.overflow = '';
				body.style.overflow = '';
				html.style.overscrollBehavior = '';
				body.style.overscrollBehavior = '';
				body.style.position = '';
				body.style.top = '';
				body.style.width = '';
				body.style.paddingRight = '';

				window.scrollTo(0, scrollYRef.current);
			}
		};
	}, [locked]);
};

